import { ENVIRONMENT, Environmet } from '@/constants/constants'

export const useEnvironment = () => {
  return { isProduction: ENVIRONMENT === Environmet.Production }
}


export const isProduction = ENVIRONMENT === Environmet.Production